import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import TestimonialService from "../services/TestimonialService";
import { useQuery } from "@tanstack/react-query";

const Review = () => {

  const [itemsPerSlide, setItemsPerSlide] = useState(3);

  useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth < 576) {
      setItemsPerSlide(1);
    } else if (window.innerWidth < 992) {
      setItemsPerSlide(2);
    } else {
      setItemsPerSlide(3);
    }
  };

  handleResize(); // initial check
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const fetchData = async () => {
    const response = await TestimonialService.getList();
    return response;
  };

  const { isPending, error, data: testimonialData } = useQuery({
    queryKey: ["testimonial"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
  });

  // Function to handle video play/pause explicitly
  const handleVideoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const video = e.currentTarget;
    
    if (video.paused) {
      video.play().catch(err => console.error("Video play failed:", err));
    } else {
      video.pause();
    }
  };

  if (isPending) return <div className="text-center p-5">Loading...</div>;

  return (
    <div className="main-container">
      <Container fluid style={{ marginTop: "clamp(4rem,8vw,9rem)" }}>
        <Row className="h-100 gy-3">
          <h1
            className="lh-1 font-level-4 fw-normal text-start p-0 mb-4 mb-md-5"
            style={{ color: "#860391"}}
          >
            HEAR FROM THOSE WHO <br className="d-none d-md-block" />
            <span className="d-md-none"> </span>STARTED SMART
          </h1>
          
          <Col lg={12} className="p-0">
            <div
              id="carouselExampleInterval"
              className="carousel slide p-0"
              data-bs-ride="false"
              data-bs-interval="false" // Ensure it doesn't auto-slide while watching
            >
             <div className="carousel-inner">
  {testimonialData &&
    // 1. Create chunks of 3 items each
    Array.from({ length: Math.ceil(testimonialData.length / itemsPerSlide) }).map((_, slideIndex) => {
      // Define the slice here so the variables are clear
      const start = slideIndex * itemsPerSlide;
      const end = start + itemsPerSlide;
      const currentBatch = testimonialData.slice(start, end);

      return (
        <div
          key={slideIndex}
          className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
        >
          <Row className="g-3 me-3">
            {currentBatch.map((item, index) => {
              // Extract YouTube ID for the iframe
              const videoId = item?.videoUrl?.split('v=')[1]?.split('&')[0] || item?.videoUrl?.split('/').pop();
              const embedUrl = `https://www.youtube.com/embed/${videoId}`;

              return (
                <Col xs={12} sm={6} md={4} key={index}>
                  <div
                    className="video-wrapper"
                    style={{
                      width: "100%",
                      height: "550px",
                      overflow: "hidden",
                      borderRadius: "20px",
                      backgroundColor: "#000",
                    }}
                  >
                    <iframe
                      width="100%"
                      height="100%"
                      src={embedUrl}
                      title={`Review ${index}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: "20px" }}
                    ></iframe>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      );
    })}
</div>
            </div>
          </Col>
        </Row>

        <Row className="mt-3 mt-md-4">
          <Col className="d-flex justify-content-center align-items-center gap-2 gap-md-3">
            <button
              className="btn p-0 border-0 bg-transparent"
              data-bs-target="#carouselExampleInterval"
              data-bs-slide="prev"
              style={{ width: "clamp(35px, 8vw, 50px)", height: "clamp(35px, 8vw, 50px)" }}
            >
              <img src={arrow} alt="Prev" style={{ rotate: "180deg", width: "100%" }} />
            </button>
            <button
              className="btn p-0 border-0 bg-transparent"
              data-bs-target="#carouselExampleInterval"
              data-bs-slide="next"
              style={{ width: "clamp(35px, 8vw, 50px)", height: "clamp(35px, 8vw, 50px)" }}
            >
              <img src={arrow} alt="Next" style={{ width: "100%" }} />
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Review;